import React, { useState } from "react";
import { lookupZip } from "../../../lib/lookupZip";
import { Loader2 } from "lucide-react";

export function ZipAutoFillInput({
  zip,
  onZipChange,
  onAddressResolved,
  placeholder = "Zip code",
  className = "",
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = async (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    onZipChange(value);
    setError("");

    if (value.length === 5 && /^\d{5}$/.test(value)) {
      try {
        setLoading(true);
        const result = await lookupZip(value);

        onAddressResolved?.(result);
      } catch (err) {
        console.error(err);
        setError("Unable to find address for this ZIP code");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="space-y-1">
      <div className="relative">
        <input
          type="text"
          value={zip}
          onChange={handleChange}
          placeholder={placeholder}
          maxLength={5}
          className={
            className ||
            "w-full px-3 py-2.5 border border-gray-300 rounded-lg text-xs pr-10"
          }
        />
        {loading && (
          <Loader2 className="w-4 h-4 animate-spin text-gray-400 absolute right-3 top-1/2 -translate-y-1/2" />
        )}
      </div>
      {error && (
        <p className="text-[11px] text-red-500">
          {error}
        </p>
      )}
      {!error && !loading && zip.length === 5 && (
        <p className="text-[11px] text-gray-400">
          Auto-filled city/state/country if available.
        </p>
      )}
    </div>
  );
}
